module.exports = __webpack_public_path__ + "images/q4otro-colorimg.jpg";